<div class="message-grid-box">
  <app-filter
    id="messageFilter"
    class="message-grid-top"
    [messageCount]="total"
    (filterChange)="onFilter($event)"
    (sortChange)="onSort($event)"
  ></app-filter>
  <div class="message-grid-bottom">
    @if (!isLoading()) {
      <div class="message-container">
        @for (message of messageList; track message) {
          <div class="message-box"
            (click)="onClickMessage(message.id)"
            [ngClass]="{ active: activeMessageId == message.id }">
            <div class="message-header">
              <div class="message-content-left">
                <h3 class="message-title" title="Namn">{{ message.heading | truncate:truncateLength }}</h3>
                <div class="message-location-container">
                  @if (message.location) {
                    <span class="message-location" title="Plats">
                      <mat-icon class="line-icon">place</mat-icon>
                    {{ message.location }}</span>
                  }
                  @if (message.affected) {
                    <span class="message-affected" title="Berörda">
                      <mat-icon class="line-icon">route</mat-icon>
                      {{ message.affected }}
                    </span>
                  }
                </div>
              </div>
              <div class="message-badges">
                <div class="platform-badge" [ngClass]="getMessageTarget(message.messageType).className">
                  <mat-icon class="platform-icon">{{ getPlatformIcon(message.messageType) }}</mat-icon>
                  <span class="platform-text">{{ getMessageTarget(message.messageType).text.toUpperCase() }}</span>
                </div>
              </div>
            </div>
            <div class="message-timing">
              <div class="timing-row">
                <mat-icon class="timing-icon">event</mat-icon>
                <span class="date-range" title="Visas från">
                  {{ message.from | date: "dd MMM HH:mm" }} -
                  @if (message.to && validDate(message.to)) {
                    <span title="Visas till">{{ message.to | date: "dd MMM HH:mm" }}</span>
                  }
                  @if (!message.to || !validDate(message.to)) {
                    <span title="Visas till">Tills vidare</span>
                  }
                </span>
              </div>
              @if (hasTimeInterval(message)) {
                <div class="timing-row">
                  <mat-icon class="timing-icon">schedule</mat-icon>
                  <span class="time-interval">
                    {{ getTimeInterval(message) }}
                  </span>
                </div>
              }
            </div>
            <div class="message-meta">
              <span class="meta-text">
                Uppdaterad {{ message.lastUpdatedAt | date: "dd MMM HH:mm" }} •
                Av <span class="meta-text-user">{{ message.createdOrUpdatedBy | userInfoFilter }}</span>
              </span>
              <mat-icon class="status-icon-inline" [ngClass]="statusToClass(message.messageStatus)" [title]="getMessageStatus(message.messageStatus)">{{ getStatusIcon(message.messageStatus) }}</mat-icon>
            </div>
          </div>
        }
      </div>
    }
    @if (!isLoading() && hasMore && !isLoadingMore) {
      <div class="message-container load-more-container">
        <button class="load-more-btn" (click)="onLoadMore()">
          Ladda fler ({{ messageList.length }} av {{ total }})
        </button>
      </div>
    }
    @if (isLoadingMore) {
      <div class="message-container">
        <app-progress-spinner
          style="left: 45%; position: relative;"
          [isLoading]="true"
          [showText]="false"
        ></app-progress-spinner>
      </div>
    }
    @if (isLoading()) {
      <div class="message-container">
        <app-progress-spinner
          style="left: 45%; position: relative;"
          [isLoading]="isLoading()"
          [showText]="true"
        ></app-progress-spinner>
      </div>
    }
    @if (errorText) {
      <div class="message-container">
        <app-error-box [errorText]="errorText"></app-error-box>
      </div>
    }
  </div>
</div>
